import { API_URL } from '@api/apiDictionary';
import { axiosMock } from '@api/client';
import { createPaginatedRandomAuditTrialsList } from '../../mocks/auditTrialsList';

type PaginatedArgs = {
  page?: number;
  size?: number;
};

export const fetchAuditTrialsListMock = async (args?: PaginatedArgs) => {
  const data = createPaginatedRandomAuditTrialsList(50, true, {
    page: args?.page ?? 1,
    size: args?.size ?? 10,
  });

  axiosMock.onGet(API_URL.auditTrial).reply(200, data);
  axiosMock.onGet(API_URL.auditTrial, {
    params: {
      page: args?.page,
      size: args?.size,
    },
  });
};

export const fetchAuditBusinessProcessesMock = () => {
  axiosMock
    .onGet(API_URL.auditBusinessProcesses)
    .reply(200, ['DATA_READ', 'DATA_QC', 'DATA_UPLOAD', 'READING']);
};
